module.exports = __webpack_public_path__ + "website/img/core4_2.bbc60ea9.png";